import { decimal, maxLength, required } from 'vuelidate/lib/validators'

import { date, maxValueAsSumOfSubMilestones, maxValueAsValueOfPart, maxValueOrNullForCondition, minValueOrMultiCurrencyMilestone, minValueOrNullForCondition, sumLowerThan } from './customValidators'

const milestoneModel = {
  name: {
    required,
    maxLength: maxLength(32)
  },
  description: {
    maxLength: maxLength(128)
  },
  paymentAmountCents: {
    minValue: minValueOrMultiCurrencyMilestone(1),
    maxValueAsSumOfSubMilestones,
    maxValueAsValueOfPart
  },
  originalDate: {
    date
  },
  forecastedDate: {
    date
  },
  expectedInvoiceDate: {
    date
  },
  expectedPaymentDate: {
    date
  },
  purchaseOrder: {
    maxLength: maxLength(64)
  },
  comment: {
    maxLength: maxLength(128)
  }
}
export const milestonesImportModel = {
  importedMilestones: {
    $each: {
      ...milestoneModel,
      subMilestones: {
        sumLowerThan: sumLowerThan('percentOfMilestone', 100),
        $each: milestoneModel
      }
    }
  }
}
export const milestoneModelForm = {
  form: milestoneModel
}
export const milestoneModelValue = {
  value: milestoneModel
}
export const subPaymentMilestonesModel = {
  form: {
    required,
    $each: {
      ...milestoneModel,
      percentOfMilestone: {
        decimal,
        minValue: minValueOrNullForCondition(0),
        maxValue: maxValueOrNullForCondition(100)
      }
    }
  }
}

export const paymentApplicationModel = {
  form: {
    name: {
      required,
      maxLength: maxLength(32)
    },
    description: {
      maxLength: maxLength(128)
    },
    applicationDate: {
      required
    },
    paymentMilestones: {
      required,
      $each: {
        paymentPart: {
          required,
          decimal
        },
        partAmountCents: {
          required,
          decimal
        }
      }
    },
    workflow: {
      required
    },
    paymentCertificate: {
      maxLength: maxLength(20)
    },
    invoiceReference: {
      maxLength: maxLength(20)
    },
    comment: {
      maxLength: maxLength(120)
    }
  }
}
